export const TOKENS = {
  ACCESS_TOKEN: "4Play_web_access_token",
  REFRESH_TOKEN: "4Play_web_refresh_token",
};
